export const NEED_HELP = "Need Help?";
export const LET_CHAT_NOW = "Let’s Chat Now!"
export const WHATSAPP = "WhatsApp"
export const LANG = "lang";
export const EN = "en";
export const ALT_KEY = {
    CANCEL: "cancel"
}
export const EVENTS = {
    WHATSAPP_CHATBOT_ICON_CLICKED: "whatsApp_chatbot_icon_clicked"
}
export const EN_CAPS = "EN";
export const SW_CAPS = "SW";
export const languageOptions = [EN_CAPS, SW_CAPS]

export const LANGUAGE_MAP = {
    "en-US": "en",
    "fr-FR": "fr"
}
export const hasLeadingZerosRegex = /^0\d+$/;
export const ACCESSIBILITY = "ACCESSIBILITY";